import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram, Facebook, ArrowUpRight, Clock } from "lucide-react";
import { navLinks, site } from "../data/siteData";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-forest-deep text-ivory">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <p className="font-display text-4xl font-semibold">Mango</p>
          <p className="text-[10px] tracking-[0.3em] uppercase text-ivory/60 mt-2">
            World Cuisine · {site.city}
          </p>
          <p className="mt-6 text-ivory/60 text-sm leading-relaxed max-w-xs">
            A world of flavours, one table. Premium multi-cuisine dining in the
            heart of Bhavnagar.
          </p>
          <div className="flex gap-3 mt-8">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Mango on Instagram"
              data-testid="footer-social-instagram"
              className="p-2.5 rounded-full border border-ivory/20 text-ivory/80 hover:bg-gold hover:text-forest hover:border-gold transition-colors duration-300"
            >
              <Instagram size={18} />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Mango on Facebook"
              data-testid="footer-social-facebook"
              className="p-2.5 rounded-full border border-ivory/20 text-ivory/80 hover:bg-gold hover:text-forest hover:border-gold transition-colors duration-300"
            >
              <Facebook size={18} />
            </a>
          </div>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs tracking-[0.25em] uppercase text-gold font-semibold">Explore</p>
          <nav className="mt-5 flex flex-col gap-3" aria-label="Footer">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                className="text-ivory/70 hover:text-gold text-sm transition-colors duration-300 w-fit"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.25em] uppercase text-gold font-semibold">Visit Us</p>
          <address className="mt-5 not-italic flex flex-col gap-4 text-sm text-ivory/70">
            <span className="flex gap-3">
              <MapPin size={16} className="shrink-0 mt-0.5 text-gold" />
              {site.addressLines.join(", ")}
            </span>
            <a
              href={`tel:${site.phoneTel}`}
              data-testid="footer-phone-link"
              className="flex gap-3 hover:text-gold transition-colors duration-300 w-fit"
            >
              <Phone size={16} className="shrink-0 mt-0.5 text-gold" />
              {site.phoneDisplay}
            </a>
            <span className="flex gap-3">
              <Clock size={16} className="shrink-0 mt-0.5 text-gold" />
              {site.hours}
            </span>
          </address>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.25em] uppercase text-gold font-semibold">Your Table</p>
          <p className="mt-5 text-sm text-ivory/60 leading-relaxed">
            Good food. Great company. A little Mango.
          </p>
          <a
            href={site.directionsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-directions-button"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-gold text-forest px-6 py-3 text-sm font-semibold transition-transform duration-300 hover:-translate-y-0.5"
          >
            Get Directions <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-ivory/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-ivory/40">
        <p>© {new Date().getFullYear()} Mango – World Cuisine Restaurant. All Rights Reserved.</p>
        <p>★ {site.rating} · {site.reviewCount} Google Reviews</p>
      </div>
    </div>
  </footer>
);
